import pageTypes from './pageTypes';

export default {
  pageTypes,
};
